import { ButtonHeaderSpinningComponent } from './button-header-spinning.component';

export default angular
  .module('sfMobile.components.button-header-spinning', [])
  .component('sfButtonHeaderSpinning', ButtonHeaderSpinningComponent).name;
